<form class="loan-form" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label for="loanAmount">Loan Amount:</label>
    <input type="number" [(ngModel)]="loanAmountStr" placeholder="Enter Loan Amount" name="loanAmountStr" id="loanAmount">
  </div>

  <div class="form-group">
    <label for="interestRate">Interest Rate (%):</label>
    <input type="number" max="30" [(ngModel)]="interestRateStr" placeholder="Enter Interest Rate" name="interestRateStr" id="interestRate">
  </div>

  <div class="form-group">
    <label for="durationYears">Duration (Years):</label>
    <input type="number" [(ngModel)]="durationYearsStr" placeholder="Enter Loan Duration in Years" name="durationYearsStr" id="durationYears">
  </div>

  <div class="form-group">
    <label for="paymentFrequency">Payment Frequency:</label>
    <select [(ngModel)]="paymentFrequency" name="paymentFrequency" id="paymentFrequency">
      <option value="monthly">Monthly</option>
      <option value="quarterly">Quarterly</option>
      <option value="annually">Annually</option>
    </select>
  </div>

  <button type="submit">Calculate</button>
</form>

<div class="tabs">
  <div class="tab" [class.active]="activeTab === 'schedule'" (click)="activeTab = 'schedule'">
    Amortization Schedule
  </div>
  <div class="tab" [class.active]="activeTab === 'chart'" (click)="activeTab = 'chart'">
    Payment Chart
  </div>
</div>

<!-- Schedule Table -->
<div class="tab-content" *ngIf="activeTab === 'schedule'">
  <table>
    <thead>
      <tr>
        <th *ngFor="let header of mortgageSchedule[0]">{{ header }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of mortgageSchedule.slice(1)">
        <td *ngFor="let cell of row">{{ cell }}</td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Highcharts Chart -->
<div class="tab-content" *ngIf="activeTab === 'chart'">
  <highcharts-chart 
    [Highcharts]="Highcharts" 
    [options]="chartOptions" 
    style="width: 100%; height: 400px; display: block;">
  </highcharts-chart>
</div>
